import { Autocomplete, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const genderOptions = [
    { label: 'Female', value: 'female' },
    { label: 'Male', value: 'male' },
    { label: 'Non-binary', value: 'nonBinary' },
    { label: 'Transgender man', value: 'transMan' },
    { label: 'Transgender woman', value: 'transWoman' },
    { label: 'Intersex', value: 'intersex' },
    { label: 'Other', value: 'other' },
    { label: 'Prefer not to say', value: 'preferNotToSay' },
]

const GenderPicker = ({ checked, selectedGender = '', setSelectedGender, setChecked }) => {
    const [value, setValue] = useState('')
    const {
        appState: {
            onboardingAnswers: { genderIdentity },
        },
    } = useSelector(state => state.assessment)
    useEffect(() => {
        if (selectedGender || genderIdentity) {
            setValue(genderOptions.find(el => el.value === selectedGender))
        } else {
            setValue('')
        }
    }, [selectedGender, genderIdentity])

    return (
        <div>
            <p
                style={{
                    fontWeight: '700',
                    paddingBottom: 12,
                }}
            >
                Which of the following most accurately describes you?
            </p>
            <Autocomplete
                disablePortal
                id="gender"
                style={{
                    border: 'none',
                    borderRadius: 0,
                    backgroundColor: 'transparent',
                    marginBottom: 16,
                    color: 'black',
                }}
                options={genderOptions}
                onChange={(event, newValue) => {
                    setSelectedGender(newValue?.value)
                    setChecked(false)
                }}
                value={value}
                onSelect={() => setChecked(false)}
                renderInput={params => (
                    <TextField
                        {...params}
                        placeholder={!selectedGender ? 'Tap to select' : ''}
                        inputProps={{ ...params.inputProps, style: { fontSize: 16 } }}
                    />
                )}
            />
        </div>
    )
}

export default GenderPicker
